import type {
  Paginated,
  SafetyCategory,
  SafetyEmployeeCard,
  SafetyMeta,
  SafetyRecordItem,
  SafetyState,
  SafetyStatusResponse,
} from '@erp/shared';
import { keepPreviousData, queryOptions } from '@tanstack/react-query';
import { api } from './api';

/** Охрана труда — все запросы под ключом ['safety'], realtime safety.changed перечитывает их. */

export const safetyMetaQuery = queryOptions({
  queryKey: ['safety', 'meta'],
  queryFn: () => api<SafetyMeta>('/safety/meta'),
  staleTime: 60_000,
});

export interface SafetyStatusFilter {
  state?: SafetyState[];
  category?: SafetyCategory;
  kindId?: string;
  departmentId?: string;
  q?: string;
}

export const safetyStatusQuery = (f: SafetyStatusFilter) =>
  queryOptions({
    queryKey: ['safety', 'status', f],
    queryFn: () =>
      api<SafetyStatusResponse>('/safety/status', {
        query: { ...f, state: f.state?.join(',') },
      }),
    placeholderData: keepPreviousData,
  });

export interface SafetyRecordsFilter {
  category?: SafetyCategory;
  kindId?: string;
  employeeId?: string;
  departmentId?: string;
  from?: string;
  to?: string;
  unsigned?: boolean;
  q?: string;
  page?: number;
  pageSize?: number;
  order?: 'asc' | 'desc';
}

export const safetyRecordsQuery = (f: SafetyRecordsFilter) =>
  queryOptions({
    queryKey: ['safety', 'records', f],
    queryFn: () =>
      api<Paginated<SafetyRecordItem>>('/safety/records', {
        query: { pageSize: 50, ...f } as never,
      }),
    placeholderData: keepPreviousData,
  });

export const safetyMyQuery = queryOptions({
  queryKey: ['safety', 'my'],
  queryFn: () => api<SafetyEmployeeCard>('/safety/my'),
});

export const safetyEmployeeQuery = (id: string) =>
  queryOptions({
    queryKey: ['safety', 'employee', id],
    queryFn: () => api<SafetyEmployeeCard>(`/safety/employees/${id}`),
  });

export const safetyCountersQuery = queryOptions({
  queryKey: ['safety', 'counters'],
  queryFn: () => api<{ unsigned: number; conduct: number }>('/safety/counters'),
  staleTime: 30_000,
  refetchInterval: 300_000,
});

export const signRecord = (id: string, as: 'employee' | 'conductor') =>
  api<SafetyRecordItem>(`/safety/records/${id}/sign`, { method: 'POST', body: { as } });
